var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-core-video-player-layers"},[_c('cover-layer'),_c('logo-layer'),_c('title-layer'),_c('play-pause-layer'),_c('loading-layer'),_c('error-layer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }